import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import showReportDownloading from '@app/actions/reports/show';
import combineActions from '@app/utils/combineActions';
import connect from '@app/utils/connect';

import classNames from '@app/ui/sports-components/utils/classNames';

const ReportDownloading = ({ reports, showReportDownloading }) => {
    const { byId, show } = reports || {};

    const showingReports = byId ? Object.values(byId).filter(r => r.isShowing) : [];
    const isShowing = showingReports && showingReports.length > 0;

    const _close = useCallback(() => {
        showReportDownloading(false);
    }, [showReportDownloading]);

    useEffect(() => {
        if ((reports && showingReports.length > 0) || !show) return;
        _close();
    }, [_close, reports, show, showingReports]);

    if (!reports) return null;

    return (
        <>
            {isShowing && show && (
                <div className="gds-corner-content gds-corner-content--right gds-corner-content--shown">
                    <div
                        className="gds-corner-content__header"
                        data-gds-corner-content=""
                    >
                        <h4 className="gds-corner-content__title -p-h-3 -p-v-2">
                            Report generating...
                        </h4>
                        <div className="gds-corner-content__controls">
                            <button
                                type="button"
                                className="gds-corner-content__button gds-button gds-button--xs gds-button--link -color-tx-lt-3 -p-h-2 -m-t-2 -m-b-0 -m-r-1"
                                onClick={_close}
                            >
                                <i className="fas fa-fw fa-times gds-text--body-md" />
                            </button>
                        </div>
                    </div>
                    {showingReports.map((r, i) => {
                        const { isDownloaded, isDownloading } = r;

                        const iconClasses = classNames('fa', 'fas', {
                            'fa-spinner': isDownloading,
                            'fa-spin': isDownloading,
                            '-color-tx-ter': isDownloading,
                            'fa-check-circle': isDownloaded,
                            '-color-tx-green': isDownloaded,
                            'fa-times-circle': !isDownloaded && !isDownloading,
                            '-color-tx-dkred': !isDownloaded && !isDownloading,
                        });

                        return (
                            <div
                                className="gds-corner-content__block -p-h-3 -p-v-2"
                                key={`${r.title}_${i}`}
                            >
                                <div className="gds-flex gds-flex--align-center">
                                    <i className="fas fa-file-pdf -m-r-2 -color-tx-dkred" />
                                    <div
                                        style={{
                                            minWidth: '88%',
                                            maxWidth: '88%',
                                        }}
                                    >
                                        <p className="gds-text--body-sm -ellipsis">
                                            {r.title}
                                        </p>
                                    </div>
                                    <div className="gds-text--header-xs -m-l-2">
                                        <i className={iconClasses} />
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </>
    );
};

ReportDownloading.propTypes = {
    reports: PropTypes.object,
    showReportDownloading: PropTypes.func.isRequired,
};

export default connect(
    ['reports'],
    combineActions({
        showReportDownloading,
    }),
)(ReportDownloading);
